import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from 'flow/SiteMonitoring/pages/Pressure/component/style'

const RemoveStateModal = ({ closeModal, confirmRemove, item }) => {
  return (
    <>
      <RemoveItemModalText data-test="modal-body">
        <FormattedMessage
          id="removeModalText"
          values={{ name: <b>{item?.name}</b> }}
        />
      </RemoveItemModalText>

      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>

        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

export default RemoveStateModal
